module.exports = __webpack_public_path__ + "img/women-reentry.c3fb4c5d.png";